module.exports = __webpack_public_path__ + "static/media/S4N6-2.f480ef16.svg";